<tiime-input-container
  tiimeFormInputContainer
  contentId="tiime-business-pro-account-intention"
  [small]="small"
  [fixedLabel]="fixedLabel"
  [label]="label"
  [errorMessage]="errorMessage?.message"
  [required]="required"
>
  <tiime-select
    id="tiime-business-pro-account-intention"
    [formControl]="control"
    (selectionChange)="emitSelectionChange($event)"
  >
    <div tiimeSelectOptions>
      @for (option of options; track option.code) {
        <mat-option [value]="option.code">
          <app-tiime-business-pro-account-intention-icon [tiimeBusinessProAccountIntention]="option.code" />
          {{ option.label }}
        </mat-option>
      }
    </div>
    <img
      class="input-suffix-asset"
      tiimeSelectSuffix
      src="assets/illu_tiime_business_card.svg"
      alt="Compte pro Tiime carte"
    />
  </tiime-select>
</tiime-input-container>
